import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cp-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
  @Input()
  label: string;

  @Input()
  icon: string;

  @Input()
  colorClass = 'branding-accent-normal-foreground';

  @Input()
  secondary = false;

  @Input()
  large = false;

  @Input()
  type: 'button' | 'submit' = 'button';

  get buttonClass() {
    return this.icon ? 'button-icon' : 'button';
  }
}
